import { useCmrServiceCmrTariffsList } from '@insurance/api/queries'
import { useValidationsField } from '@insurance/hooks'
import { Col, Form, Row, Select } from 'antd'
import { useTranslation } from 'react-i18next'

import { useCmrInsuranceValues } from './CmrInsuranceContext'
import { formProps } from './utils'

export const TariffAmountFields = () => {
  const { t } = useTranslation()
  const { required } = useValidationsField()
  const formInstance = Form.useFormInstance()
  const { isEditable, isApprove } = useCmrInsuranceValues()

  const {
    totalAmountProps,
    perCaseAmountProps,
    periodProps,
    generalCargoProps,
    highRiskCargoProps,
    currencyAmountProps
  } = formProps(t)

  const period = Form.useWatch(periodProps.name)
  const selectedTotalAmount = Form.useWatch(totalAmountProps.name)
  const generalCargo = Form.useWatch(generalCargoProps.name)
  const highRiskCargo = Form.useWatch(highRiskCargoProps.name)

  const category = highRiskCargo
    ? 'high_risk_cargo'
    : generalCargo
    ? 'general_cargo'
    : undefined

  const { data: tariffs = [], isLoading } = useCmrServiceCmrTariffsList({
    period,
    category
  })

  const totalAmountOptions = [
    ...new Set(tariffs.map((tariff) => tariff.total_amount))
  ].map((value) => ({ label: value, value }))

  const perCaseAmountOptions = [
    ...new Set(
      tariffs
        .filter(
          (tariff) =>
            !selectedTotalAmount || tariff.total_amount === selectedTotalAmount
        )
        .map((tariff) => tariff.per_case_amount)
    )
  ].map((value) => ({ label: value, value }))

  return (
    <Row gutter={[12, 12]}>
      <Col xs={24} lg={8}>
        <Form.Item {...totalAmountProps} rules={[required]}>
          <Select
            loading={isLoading}
            placeholder={totalAmountProps.label}
            options={totalAmountOptions}
            onChange={() => {
              formInstance.setFieldsValue({
                [perCaseAmountProps.name]: undefined
              })
            }}
          />
        </Form.Item>
      </Col>

      <Col xs={24} lg={8}>
        <Form.Item {...perCaseAmountProps} rules={[required]}>
          <Select
            loading={isLoading}
            placeholder={perCaseAmountProps.label}
            options={perCaseAmountOptions}
          />
        </Form.Item>
      </Col>

      <Col xs={24} lg={8}>
        <Form.Item {...currencyAmountProps}>
          <Select
            disabled={isEditable || isApprove}
            placeholder={currencyAmountProps.label}
            options={[
              { value: 'EUR', label: 'EUR' },
              { value: 'USD', label: 'USD' }
            ]}
          />
        </Form.Item>
      </Col>
    </Row>
  )
}
